












import { namespace } from 'vuex-class'
import { Vue, Component, Watch } from 'vue-property-decorator'
import DocumentationsLayout from '@/UI/Auction/Documentations/DocumentationsLayout.vue'
import { DocumentationsData } from '@/Infrastructure/Store/Auction/DocumentationsData'
import { PersonalData as VuexPersonalData } from '@/Infrastructure/Store/Auction/PersonalData'
import { DocumentationValidatorResolverProvider, DocumentationValidatorResolver } from '@/Infrastructure/Documentations/Validator'

const auctionStore = namespace('auction')
const procedureStore = namespace('procedure')

@Component({
  components: {
    DocumentationsLayout
  }
})
export default class Documentations extends Vue {
  @auctionStore.Getter
  public docOptionSelected!: number

  @procedureStore.Getter
  currentProcedureId!: string

  @procedureStore.Getter
  currentProcedureType!: string

  @auctionStore.Getter
  public personalData!: VuexPersonalData

  @auctionStore.Getter
  public documentationsData!: DocumentationsData[]

  @auctionStore.Action
  public setDocOptionSelected!: (option: number) => void

  @auctionStore.Action
  public setDocumentations!: (DocumentationsData: DocumentationsData[]) => void

  documentationNeeded: number[] = []

  documentValidatorResolver!: DocumentationValidatorResolver

  get allDocumentsPresent (): boolean {
    if (this.documentationsData.length < 1 || this.documentationsData.length !== this.documentationNeeded.length) {
      return false
    }
    let allDocumentsPresent = true
    for (const item of this.documentationsData) {
      const documentationId = item.idItem
      allDocumentsPresent = allDocumentsPresent &&
        this.documentationNeeded.indexOf(documentationId) !== -1
    }
    return allDocumentsPresent
  }

  get isValid (): boolean {
    if (this.docOptionSelected === 0) {
      return false
    }
    const validator = this.documentValidatorResolver.resolve(this.currentProcedureType)
    const documentIds:number [] = []
    this.documentationsData.map(current => {
      if (this.validateDocumentationData(current)) {
        documentIds.push(current.idItem)
      }
    })
    return validator.validateDocuments(this.docOptionSelected, documentIds)
  }

  @Watch('isValid')
  onIsValidChanged (newValue: boolean): void {
    this.$emit('validForm', {
      validForm: newValue,
      step: 5
    })
  }

  created (): void {
    const documentValidatorResolverProvider = new DocumentationValidatorResolverProvider()
    this.documentValidatorResolver = documentValidatorResolverProvider.provide()
    this.$emit('validForm', {
      validForm: this.isValid,
      step: 5
    })
  }

  public onUserTypeChanged ($event: { userType: number; documentationNeeded: number[] }): void {
    if (this.docOptionSelected !== $event.userType) {
      this.setDocumentations([])
    }
    this.setDocOptionSelected($event.userType)
    this.documentationNeeded = $event.documentationNeeded
  }

  public onDocumentationUpdated ($event: DocumentationsData[]): void {
    this.setDocumentations($event)
  }

  public validateDocumentationData (item: DocumentationsData): boolean {
    if (item.checked === false) {
      return false
    }
    if (item.presentada === false && item.file === '') {
      return false
    }
    const presentadaDataValid = item.organo !== '' && item.ano !== '' && item.codProcedemento !== ''
    if (item.presentada === true && presentadaDataValid === false) {
      return false
    }
    return true
  }
}
